import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * `eventName` matches the `type` of the actions dispatched by the create, save, deactivate and
 * restore functions, and of the transcription's call-settings save. The failure of a fetch is deliberately not covered: the screens surface it
 * inline, as an error state with a retry.
 */
const DocumentGroupsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="ORGANIZATION_WORKFLOW_CREATED"
				title="Groupe créé"
				message="Le groupe de documents a bien été créé."
			/>
			<SuccessNotification
				eventName="ORGANIZATION_WORKFLOW_SAVED"
				title="Groupe enregistré"
				message="Une nouvelle version du groupe de documents a été publiée."
			/>
			<SuccessNotification
				eventName="ORGANIZATION_WORKFLOW_DEACTIVATED"
				title="Désactivé"
				message="La désactivation a bien été enregistrée."
			/>
			<SuccessNotification
				eventName="ORGANIZATION_WORKFLOW_RESTORED"
				title="Réactivé"
				message="La réactivation a bien été enregistrée."
			/>
			<SuccessNotification
				eventName="ORGANIZATION_WORKFLOW_OPTIONS_SAVED"
				title="Chaîne enregistrée"
				message="L’option a bien été enregistrée."
			/>
			<SuccessNotification
				eventName="USAGE_SETTINGS_SAVED"
				title="Réglages enregistrés"
				message="Les réglages de transcription ont bien été enregistrés."
			/>
			<ErrorNotification
				eventName="USAGE_SETTINGS_SAVE_FAILED"
				title="Erreur"
				message="Les réglages de transcription n’ont pas pu être enregistrés."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_WORKFLOW_OPTIONS_SAVE_FAILED"
				title="Erreur"
				message="L’option n’a pas pu être enregistrée."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_WORKFLOW_CREATION_FAILED"
				title="Erreur"
				message="Le groupe de documents n’a pas pu être créé."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_WORKFLOW_SAVE_FAILED"
				title="Enregistrement refusé"
				message="Le groupe de documents n’a pas pu être enregistré."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_WORKFLOW_DEACTIVATION_FAILED"
				title="Erreur"
				message="La désactivation n’a pas pu être enregistrée."
			/>
			<ErrorNotification
				eventName="ORGANIZATION_WORKFLOW_RESTORATION_FAILED"
				title="Erreur"
				message="La réactivation n’a pas pu être enregistrée."
			/>
		</React.Fragment>
	);
};

export default DocumentGroupsNotifications;
